import { render, staticRenderFns } from "./videoupload.vue?vue&type=template&id=70401473&scoped=true&"
import script from "./videoupload.vue?vue&type=script&lang=js&"
export * from "./videoupload.vue?vue&type=script&lang=js&"
import style0 from "./videoupload.vue?vue&type=style&index=0&id=70401473&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70401473",
  null
  
)

export default component.exports